import { render, staticRenderFns } from "./DeviceMessage.vue?vue&type=template&id=63bc5cdc&scoped=true&"
import script from "./DeviceMessage.vue?vue&type=script&lang=ts&"
export * from "./DeviceMessage.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceMessage.vue?vue&type=style&index=0&id=63bc5cdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc5cdc",
  null
  
)

component.options.__file = "DeviceMessage.vue"
export default component.exports